import ReactGA from 'react-ga4'

interface AnalyticsEvent {
  category: string
  action: string
  label?: string
  value?: number
}

export const initGA = (measurementId: string): void => {
  ReactGA.initialize(measurementId)
}

export const logPageView = (path: string): void => {
  ReactGA.send({ hitType: 'pageview', page: path })
}

export const logEvent = ({ category, action, label, value }: AnalyticsEvent): void => {
  ReactGA.event({
    category,
    action,
    label,
    value
  })
} 